















































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { omegaup } from '../../omegaup';
import T from '../../lang';
import country_Flag from '../CountryFlag.vue';
import omegaup_Markdown from '../Markdown.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCogs } from '@fortawesome/free-solid-svg-icons';
library.add(faCogs);

@Component({
  components: {
    'omegaup-country-flag': country_Flag,
    'omegaup-markdown': omegaup_Markdown,
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class SchoolOfTheMonthList extends Vue {
  @Prop() schoolsOfPreviousMonths!: omegaup.SchoolOfTheMonth[];
  @Prop() schoolsOfPreviousMonth!: omegaup.SchoolOfTheMonth[];
  @Prop() candidatesToSchoolOfTheMonth!: omegaup.SchoolOfTheMonth[];
  @Prop() isMentor!: boolean;
  @Prop() canChooseSchool!: boolean;
  @Prop() schoolIsSelected!: boolean;
  @Prop({ default: true }) isDisabled!: boolean;

  T = T;
  selectedTab = 'allSchoolsOfTheMonth';

  get visibleSchools(): omegaup.SchoolOfTheMonth[] {
    switch (this.selectedTab) {
      case 'allSchoolsOfTheMonth':
      default:
        return this.schoolsOfPreviousMonths;
      case 'schoolsOfPreviousMonth':
        return this.schoolsOfPreviousMonth;
      case 'candidatesToSchoolOfTheMonth':
        return this.candidatesToSchoolOfTheMonth;
    }
  }
}
